"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _slateReact = require("slate-react");

var _slateHtmlSerializer = _interopRequireDefault(require("slate-html-serializer"));

var _FormatToolbar = _interopRequireDefault(require("./FormatToolbar/FormatToolbar"));

var _rules = _interopRequireDefault(require("./utilities/rules"));

var _icons = _interopRequireDefault(require("./icons"));

require("./RichTextEditor.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var html = new _slateHtmlSerializer["default"]({
  rules: _rules["default"]
});

var RichTextEditor =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RichTextEditor, _React$Component);

  function RichTextEditor(_props) {
    var _this;

    _classCallCheck(this, RichTextEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RichTextEditor).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "ref", function (editor) {
      _this.editor = editor;
    });

    _defineProperty(_assertThisInitialized(_this), "hasMark", function (type) {
      var value = _this.state.value;
      return value.activeMarks.some(function (mark) {
        return mark.type === type;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (_ref) {
      var value = _ref.value;

      _this.setState({
        value: value
      });

      var formatted = html.serialize(value); // bubble the html content back to parent

      _this.props.onChange && _this.props.onChange(formatted);
    });

    _defineProperty(_assertThisInitialized(_this), "onFormatClick", function (event, type) {
      event.preventDefault();

      _this.editor.toggleMark(type);
    });

    _defineProperty(_assertThisInitialized(_this), "renderMark", function (props, editor, next) {
      var mark = props.mark,
          attributes = props.attributes;

      switch (mark.type) {
        case 'bold':
          return _react["default"].createElement("strong", attributes, props.children);

        case 'italic':
          return _react["default"].createElement("em", attributes, props.children);

        case 'underlined':
          return _react["default"].createElement("u", attributes, props.children);

        case 'code':
          return _react["default"].createElement("code", attributes, props.children);

        default:
          return next();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderBlock", function (props, editor, next) {
      var attributes = props.attributes,
          children = props.children,
          node = props.node;

      switch (node.type) {
        case 'quote':
          return _react["default"].createElement("blockquote", attributes, children);

        case 'bulleted-list':
          return _react["default"].createElement("ul", attributes, children);

        case 'heading-one':
          return _react["default"].createElement("h1", attributes, children);

        case 'heading-two':
          return _react["default"].createElement("h2", attributes, children);

        case 'heading-three':
          return _react["default"].createElement("h3", attributes, children);

        case 'heading-four':
          return _react["default"].createElement("h4", attributes, children);

        case 'heading-five':
          return _react["default"].createElement("h5", attributes, children);

        case 'heading-six':
          return _react["default"].createElement("h6", attributes, children);

        case 'list-item':
          return _react["default"].createElement("li", attributes, children);

        case 'numbered-list':
          return _react["default"].createElement("ol", attributes, children);

        default:
          return next();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderMarkButton", function (type, icon) {
      return _react["default"].createElement("button", {
        onClick: function onClick(event) {
          return _this.onFormatClick(event, type);
        },
        className: "kt-rte-tooltip-icon-button",
        style: {
          opacity: _this.hasMark(type) ? 1 : 0.25
        }
      }, icon);
    });

    _this.state = {
      activeTextFormats: [],
      value: html.deserialize(_props.value || '<p></p>')
    };
    return _this;
  }

  _createClass(RichTextEditor, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "kt-rte-container"
      }, _react["default"].createElement(_FormatToolbar["default"], null, this.renderMarkButton('bold', _react["default"].createElement(_icons["default"].Bold, null)), this.renderMarkButton('italic', _react["default"].createElement(_icons["default"].Italicize, null)), this.renderMarkButton('underline', _react["default"].createElement(_icons["default"].Underline, null)), this.renderMarkButton('code', _react["default"].createElement(_icons["default"].Code, null))), _react["default"].createElement(_slateReact.Editor, {
        ref: this.ref,
        value: this.state.value,
        onChange: this.handleChange,
        renderMark: this.renderMark,
        renderBlock: this.renderBlock,
        renderEditor: function renderEditor(props, editor, next) {
          var children = next();
          return _react["default"].createElement("div", {
            className: "kt-rte-text-container"
          }, children);
        }
      }));
    }
  }]);

  return RichTextEditor;
}(_react["default"].Component);

exports["default"] = RichTextEditor;
RichTextEditor.propTypes = {
  value: _propTypes["default"].string,
  // html string
  onChange: _propTypes["default"].func // bubble changes up to parent component

};